import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {ProspectActivity, ApplyWorkflowProspectActivity} from 'api';
import {Link, useRouteMatch} from 'react-router-dom';

interface ApplyWorkflowAcvitity extends ProspectActivity {
  resource: ApplyWorkflowProspectActivity;
}

interface Props {
  prospectActivity: ApplyWorkflowAcvitity;
}

const ApplyWorkflowActivityComponent = ({prospectActivity}: Props) => {
  const {resource: {workflow = {}} = {}} = prospectActivity;
  const {url} = useRouteMatch();

  return (
    <>
      <Icon />
      <Content>
        <span>
          ワークフロー：
          <Link to={`${url.replace('timeline', 'workflow')}${location.search}`}>
            {workflow.name}
          </Link>
        </span>
        <time>
          {moment(prospectActivity.createdAt).format('YYYY/MM/DD HH:mm')}
        </time>
      </Content>
    </>
  );
};

const Content = styled.div`
  display: flex;
  flex: 1;
  width: 455px;
  margin-top: -4px;
  margin-left: 3px;

  span:first-child {
    flex: 1;
    margin: 0;
    color: var(--text-color-1);
    font-weight: 500;
    width: 375px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span,
  time {
    color: var(--text-color-2);
    margin-left: 15px;
  }
`;

const Icon = styled.span`
  height: 10px;
  width: 10px;
  background: #c4c4c4;
  border-radius: 50%;
  margin-left: 10px;
  margin-right: 15px;
  z-index: 1;
`;

export default ApplyWorkflowActivityComponent;
